@if (isAuthenticated$ | async) {
  <form
    class="contents"
    [formGroup]="form"
    (ngSubmit)="onSubmit()"
    [appScrollToInvalidFieldOnFormSubmit]
    [scrollElement]="ScrollElements.WINDOW"
  >
    <app-cart-summary />
    <div class="form border-radius">
      <app-billing-information [extendedForm]="true" />
      @let orderDetails = orderDetails$ | async;
      @if (orderDetails && sum(orderDetails) > 0) {
        <app-payment-information [required]="true" />
      }
    </div>
  </form>
} @else {
  <app-cart-summary />
  <div class="container">
    <div class="auth">
      <div class="form border-radius">
        <div class="form__block">
          <app-sign-in-page />
        </div>
      </div>
    </div>
  </div>
}
